var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-input-select',{attrs:{"input-label":_vm.$t('calling_times'),"options":_vm.options,"id":'callingTimes' + _vm.uniqueId,"name":'callingTimes' + _vm.uniqueId,"default-value":_vm.callingTimes},on:{"update-value":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }